import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  let user = null;
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedUser !== "undefined") {
      user = JSON.parse(storedUser);
    }
  } catch {
    user = null;
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  const verified =
    Number(user.licence_verified) === 1 && user.verified_id === "Y";

  if (!verified) {
    return <Navigate to="/verify-licence" replace />;
  }

  return children;
};

export default ProtectedRoute;